<div
  class="bg-surface-enabled-primary max-h-[80vh] overflow-scroll shadow border border-stroke-enabled rounded-[8px] p-[16px] mt-[8px]">

  @if (carregando) {
  <div>
    <mat-spinner diameter="30"></mat-spinner>
  </div>
  }

  @if (!carregando) {
  <div class="seguradoras acesso-rapido">
    <span class="sub-title">Seguradoras</span>
    <div class="seguradoras-grid">

      @for (confSeg of confsSeguradoras; track $index) {
      <div class="border rounded-md p-1 px-2 flex items-center justify-center">
        <button mat-icon-button [disabled]="!confSeg.credenciaisValidas"
          (click)="acessaSeguradora(confSeg.idIntegracao)" class="itemSeg">

          @if (!carregando) {
          <img [src]="confSeg.imgIcone" (error)="confSeg.imgIcone = 'assets/img/fallback/seguradora.png'"
            [matTooltipClass]="{'default' : true}"
            [matTooltip]="confSeg.credenciaisValidas ?  confSeg.nomeSeguradora : confSeg.nomeSeguradora + ' / Credenciais Inválidas'">
          }
        </button>
      </div>
      }
    </div>
  </div>
  }

  @if (!carregando && confsSeguradorasInvalidas.length > 0) {
  <div class="seguradorasInv acesso-rapido">
    <span class="sub-title">Credenciais inválidas</span>
    <div class="seguradorasInv-grid">

      @for (confSeg of confsSeguradorasInvalidas; track $index) {
      <div class="border rounded-md p-1 px-2 flex items-center justify-center">
        <button mat-icon-button [disabled]="!confSeg.credenciaisValidas"
          (click)="acessaSeguradora(confSeg.idIntegracao)" class="itemSeg">

          @if (!carregando) {
          <img [src]="confSeg.imgIcone" [matTooltipClass]="{'toolColor' : true}"
            [matTooltip]="confSeg.credenciaisValidas ?  confSeg.nomeSeguradora : confSeg.nomeSeguradora + ' / Credenciais Inválidas'">
          }
        </button>
      </div>
      }
    </div>
  </div>
  }
</div>

<!-- <div class="w-[337px] bg-surface-enabled-primary shadow border border-stroke-enabled rounded-[8px] p-[16px] mt-[8px]">
  Teste
</div> -->